import {Navigate} from "react-router-dom";
import {useUserAttributes} from "../../../hooks/useUserAttributes.ts";
import {MarketingComponent} from "../components/MarketingComponent.tsx";

export const PublicHomePage = () => {

    const {email} = useUserAttributes();

    if (email) {
        return <Navigate to={'/dashboard'}/>;
    } else {
        return <MarketingComponent/>;
    }


};
